<template>
    <div class="news">
        <div 
            class="news__inner" 
            @click="openNews" >
            <h1 class="news__heading">Новость №: {{news_data.id}}</h1>
            <p class="news__date">От: {{news_data.created}}</p>
            <p class="news__heading">{{news_data.name}}</p>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        news_data: {
            type: Object,
            default(){
                return{

                }
            }
        },
    },
    methods: {
        openNews(){
            this.$emit('openNews', this.news_data.id)
        },

    }
}
</script>

<style scoped>
    .news__inner{
        max-width: 600px;
        margin: 25px 0;
        padding: 10px;
        width: 100%;
        box-shadow: 4px 4px 10px rgb(0 0 0 / 25%);
        border: 1px solid #000;
        border-radius: 5px;
        background-color: #fff;
    }
    .news__heading{
        font-size: 18px;
    }
    .full-news__ypd{
        margin-top: 10px;
        font-size: 14px;
    }
    .full-news__ypd-date{
        font-size: 14px;
        margin-bottom: 10px;
    }
    .news__service{
        display: inline-block;
        font-size: 14px;
        margin: 5px 0;
        padding-bottom: 2px;
        border-bottom: 1px solid #000;
    }
    .news__delivery{
        display: inline-block;
        font-size: 14px;
        margin: 5px 0;
        padding-bottom: 2px;
        border-bottom: 1px solid #000;
    }
    .news__date{
        font-size: 14px;
        margin-bottom: 5px;
    }
    .news__status{
        font-size: 14px;
        padding-bottom: 10px;
    }
    .news__waiting{
        font-size: 14px;
        font-weight: 700;
        margin-bottom: 5px;
    }
    .news__notification{
        display: flex;
        justify-content: space-between;
    }
    .news__info{
        font-size: 14px;
        font-style: italic;
        margin-top: 10px;
    }
    .news__hot{
        color: red;
        display: inline-block;
        font-weight: 700;
        margin-bottom: 5px;
    }
    .yellow{
        background-color: rgba(230, 230, 0, .6);
    }
    .green{
        background-color: rgba(33, 201, 0, 0.6);
    }
    .red{
        background-color: rgba(255, 0, 0, 0.5);
    }
    .isNeedPayDoc{
        background: url(../images/pay-dock-ico.png) no-repeat;
        background-size: 40px 40px;
        background-position: 98% 10px;
    }
</style>